export const REPORT_PAGE_LAYOUT_RULES: string[] = [
    'Use Bootstrap row and col-* classes for Report Page layout structure.',
    'Use Report Item placeholders exactly as {1234}. Do not change placeholder IDs.',
    'Return only drop-in ready Report Page Layout HTML when asked to create or correct a layout.',
    'Do not include markdown fences, explanation, labels, or surrounding commentary in a generated layout suggestion.',
    'Do not include script tags, style tags, event handlers, external links, images, iframes, or arbitrary JavaScript.',
    'Do not add an outer scrolling container. The RetainBI runtime owns page scrolling.',
    'Avoid overflow-y:auto and overflow-x:auto in Report Page Layout HTML unless the user explicitly asks for a local scroll region.',
    'Avoid h-100 unless every parent height is intentionally controlled.',
    'Avoid nested cards around Report Item placeholders. RetainBI already renders each Report Item frame.',
    'Avoid card and chart-padding classes around normal Report Item placeholders unless the layout is intentionally building summary tiles.',
    'Prefer simple rows with explicit heights for chart/table regions, such as style="height:300px;".',
    'For one full-width item, prefer <div class="row"><div class="col-12">{1234}</div></div>.',
    'For two side-by-side items, prefer one row with two col-6 columns.',
    'For three side-by-side items, prefer one row with three col-4 columns.',
    'Do not create empty columns for spacing unless the user explicitly asks for centered/narrow content.',
    'Do not use w-100 on rows unless needed; Bootstrap rows already span their container.',
];

export const buildReportPageLayoutRulesText = (): string => {
    return REPORT_PAGE_LAYOUT_RULES
        .map((rule, index) => `${index + 1}. ${rule}`)
        .join('\n');
};

export const extractAIReportPageLayoutSuggestionText = (rawResponseText: string): string => {
    const trimmedResponseText = rawResponseText.trim();

    if (trimmedResponseText.startsWith('```')) {
        return trimmedResponseText
            .replace(/^```[a-zA-Z]*\s*/, '')
            .replace(/\s*```$/, '')
            .trim();
    }

    return trimmedResponseText;
};
